import gql from 'graphql-tag'

const statsPubblicitaLineChartAndamentoAnnuale = gql`
  query statsPubblicitaLineChartAndamentoAnnuale(
    $tipoAndamento: TipoAndamentoPubblicita
    $anno: Int!
    $tipologiaFiltroRisultati: TipologiaFiltroRisultati
    $nazione: String
  ) {
    statsPubblicitaLineChartAndamentoAnnuale(
      tipoAndamento: $tipoAndamento
      anno: $anno
      tipologiaFiltroRisultati: $tipologiaFiltroRisultati
      nazione: $nazione
    ) {
      nome
      valori
    }
  }
`

export default statsPubblicitaLineChartAndamentoAnnuale



// WEBPACK FOOTER //
// ./src/graphql/queries/statsPubblicitaLineChartAndamentoAnnuale.js